import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import ChipSelect from '../common/ChipSelect';

import FabricInfo from './FabricInfo';

const FabricSelectionLegend = (
    <FormattedMessage
        id='FABRIC_SELECTION_LEGEND'
        description='Label of the fabric selection form element.'
        defaultMessage='Stoff wählen'
    />
);

/**
 * Fabric selection component.
 */
const FabricSelection = ({ fabrics, activeFabricId, handleFabricChange, wrapper, helpText }) => {
    const onFabricChange = value => handleFabricChange(value);

    const buildFabrics = () => {
        const Fabrics = Object.keys(fabrics).map(fabricId => (
            {
                value: fabricId,
                label: fabrics[fabricId].title,
            }
        ));
        return Fabrics;
    };

    const Wrapper = styled(wrapper)`
         & .schnoffle-chip-default {
           margin: 0.5em 1em 0.5em 0;
           transition: background-color 0.5s ease, color 0.5s ease;
           &:hover {
             background-color: ${props => props.theme.palette.secondary.light};
           }
           &:focus {
             background-color: ${props => props.theme.palette.secondary.main};
             color: white;
           }
         }
        & .schnoffle-chip-selected {
          transition: background-color 0.5s ease, color 0.5s ease;
          color: white;
          background-color: ${props => props.theme.palette.secondary.main};
        }
        & .schnoffle-chip-default.schnoffle-chip-disabled {
           margin: 0.5em 1em 0.5em 0;
           transition: background-color 0.5s ease, color 0.5s ease;
           color: #AAA;
           &:hover {
             background-color: #DDD;
             cursor: not-allowed;
           }
           &:focus {
             background-color: #DDD;
             cursor: not-allowed;
           }
         }
         & .schnoffle-flex {
            display: flex;
            flex-wrap: nowrap;
         }
    `;

    return (
        <Wrapper className='stolo-cart-item'>
            <legend>
                {FabricSelectionLegend}
            </legend>
            <ChipSelect
                handleChange={onFabricChange}
                defaultChipID={activeFabricId}
                data={buildFabrics()}
            />
            <FabricInfo fabricInfo={fabrics[activeFabricId]} />
        </Wrapper>
    );
};

export default FabricSelection;



// WEBPACK FOOTER //
// ./src/components/addtocart/FabricSelection.js